import { IUser } from 'interface/user.interface';
import { ReactNode } from 'react';
import formatNumber from 'utils/formatNumber';

export interface IProps {
  data: any[];
  dataExport?: any;
  //   fileName?: string;
  header?: any;
  user?: IUser;
}

export default function generateData(props: IProps) {
  const { dataExport, header, data, user } = props;

  const convertStatus = (status: number) => {
    switch (status) {
      case undefined:
      case null:
      case 0:
        return 'Mới tạo';
      case 1:
        return 'Đã gửi yêu cầu duyệt';
      case 2:
        return 'Đã duyệt';
      case 3:
        return 'Từ chối';
      default:
        return '-';
    }
  };

  const convertASMStatus = (status: number) => {
    switch (status) {
      case undefined:
      case null:
        return '_';
      case 0:
        return 'Chưa duyệt';
      case 1:
        return 'Đã duyệt';
      case 2:
        return 'Từ chối';
      default:
        return '-';
    }
  };

  const convertPofType = (pof_type: string) => {
    switch (pof_type) {
      case undefined:
      case null:
      case 'suggest':
        return 'Khuyến nghị';
      case 'other':
        return 'Ngoài danh mục';
      case 'trial':
        return 'Hàng mới';
      default:
        return '-';
    }
  };

  const convertCapitalStatus = (status: number) => {
    switch (status) {
      case undefined:
      case null:
        return '_';
      case 0:
        return 'Mới tạo';
      case 1:
        return 'Lưu nháp';
      case 2:
        return 'Đã phân bổ';
      default:
        return '-';
    }
  };

  dataExport.forEach((prm) => {
    const rowData = header.map((column) => {
      if (
        column.dataIndex == 'capital_min' ||
        column.dataIndex == 'capital_max'
      ) {
        return Number(prm[column.dataIndex]);
      } else if (column.dataIndex == 'status') {
        return user?.role.includes('asm')
          ? convertASMStatus(prm['asm_approve_status'])
          : convertStatus(prm[column.dataIndex]);
      } else if (column.dataIndex == 'pof_type') {
        return convertPofType(prm[column.dataIndex]);
      } else if (column.dataIndex == 'capital_branch_status') {
        return convertCapitalStatus(prm[column.dataIndex]);
      } else if (
        column.dataIndex == 'date_started' ||
        column.dataIndex == 'date_end' ||
        column.dataIndex == 'create_at' ||
        column.dataIndex == 'created_at' ||
        column.dataIndex == 'request_date' ||
        column.dataIndex == 'send_approve_at'
      ) {
        const data = prm[column.dataIndex]
          ? prm[column.dataIndex].slice(0, 10)
          : '';
        return data;
      } else if (
        column.dataIndex == 'cap_order_min' ||
        column.dataIndex == 'cap_order_max' ||
        column.dataIndex == 'per_cap_order_min' ||
        column.dataIndex == 'per_cap_order_max' ||
        column.dataIndex == 'cap_reorder_min' ||
        column.dataIndex == 'cap_reorder_max' ||
        column.dataIndex == 'per_cap_reorder_min' ||
        column.dataIndex == 'per_cap_reorder_max' ||
        column.dataIndex == 'cap_other_min' ||
        column.dataIndex == 'cap_other_max' ||
        column.dataIndex == 'per_cap_other_min' ||
        column.dataIndex == 'per_cap_other_max' ||
        column.dataIndex == 'ratio_min' ||
        column.dataIndex == 'ratio_max' ||
        column.dataIndex == 'total_cabinet' ||
        column.dataIndex == 'min_register' ||
        column.dataIndex == 'max_register' ||
        column.dataIndex == 'max_plan' ||
        column.dataIndex == 'capital_value'
      ) {
        return prm[column.dataIndex] ? Number(prm[column.dataIndex]) : 0;
      } else return prm[column.dataIndex]?.toString();
    });
    data.push(rowData);
  });
  return data;
}
